import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useState } from 'react';
import type { PromoEditorInterface } from '@/types';
export const usePromoInitialValues = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      action: "add",
      skusFile: undefined,
      promoName: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [initialValues, setInitialValues] = useState(t0);
  let t1;
  if ($[1] !== initialValues) {
    t1 = [initialValues, setInitialValues];
    $[1] = initialValues;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};